import { profile, socialLinks } from "./site";
import { projects } from "./projects";

export const siteUrl = "https://anshjatana.online";

export const seo = {
  siteName: "Ansh Jatana — Portfolio",
  title: "Ansh Jatana | Frontend Engineer · React · Next.js · TypeScript",
  description:
    "Ansh Jatana is a product-minded Frontend Engineer based in Gurugram, India. Founding tech member at Clinikally (YC S22). Builds fast, scalable web apps with React, Next.js, TypeScript, and AI-powered products.",
  keywords: [
    "Ansh Jatana",
    "Frontend Engineer",
    "React developer",
    "Next.js developer",
    "TypeScript developer",
    "Gurugram developer",
    "India frontend engineer",
    "YC startup engineer",
    "Clinikally",
    "portfolio",
    "SaaS developer",
    "AI product engineer",
  ].join(", "),
  author: profile.name,
  locale: "en_IN",
  ogImage:
    "https://res.cloudinary.com/dywhcxdix/image/upload/v1732440384/Portfolio_assets/y5gvidf48toxhkgr2xlu.jpg",
  twitterHandle: "@anshh_jatana",
};

export const faqItems = [
  {
    question: "Who is Ansh Jatana?",
    answer:
      "Ansh Jatana is a self-taught Frontend Engineer based in Gurugram, India. He is a product-minded developer who builds fast, scalable web experiences with React, Next.js, and TypeScript.",
  },
  {
    question: "Where does Ansh Jatana work?",
    answer:
      "Ansh Jatana is a Frontend Engineer at Clinikally (YC S22), a large-scale consumer marketplace. He previously interned at Wardroll, a B2B SaaS platform for fashion creators.",
  },
  {
    question: "What technologies does Ansh Jatana use?",
    answer:
      "Ansh Jatana works with React.js, Next.js, TypeScript, JavaScript, Node.js, Nest.js, Tailwind CSS, React Query, Turborepo, PostHog, Sentry, Supabase, and AWS. He also ships AI-powered products and agentic workflows.",
  },
  {
    question: "How can I contact Ansh Jatana?",
    answer:
      "You can contact Ansh Jatana via email at anshjatana1111@gmail.com, through the contact form at anshjatana.online, or on LinkedIn at linkedin.com/in/ansh-jatana-10b446205.",
  },
  {
    question: "What projects has Ansh Jatana built?",
    answer:
      "Notable projects include Wardroll (B2B SaaS), Git Pulse (GitHub analytics), Format your Date (NPM package with 500+ downloads), CryptoBazar (real-time crypto app), and Clara AI Skin Analyser at Clinikally.",
  },
];

export const knowsAbout = [
  "Frontend Engineering",
  "React",
  "Next.js",
  "TypeScript",
  "JavaScript",
  "Node.js",
  "System Design",
  "UI/UX",
  "AI Products",
  "SaaS",
  "Web Performance",
  "SEO",
];

export const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Person",
      "@id": `${siteUrl}/#person`,
      name: profile.name,
      givenName: profile.firstName,
      jobTitle: profile.title,
      description: seo.description,
      url: siteUrl,
      email: profile.email,
      image: seo.ogImage,
      address: {
        "@type": "PostalAddress",
        addressLocality: profile.location,
        addressRegion: "Haryana",
        addressCountry: "IN",
      },
      sameAs: socialLinks.filter((l) => l.href.startsWith("http")).map((l) => l.href),
      knowsAbout,
      worksFor: {
        "@type": "Organization",
        name: "Clinikally",
        description: "YC S22 consumer marketplace",
      },
    },
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      url: siteUrl,
      name: seo.siteName,
      description: seo.description,
      inLanguage: "en-IN",
      publisher: { "@id": `${siteUrl}/#person` },
    },
    {
      "@type": "ProfilePage",
      "@id": `${siteUrl}/#profilepage`,
      url: siteUrl,
      name: seo.title,
      description: seo.description,
      isPartOf: { "@id": `${siteUrl}/#website` },
      about: { "@id": `${siteUrl}/#person` },
      primaryImageOfPage: seo.ogImage,
    },
    {
      "@type": "FAQPage",
      "@id": `${siteUrl}/#faq`,
      mainEntity: faqItems.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer,
        },
      })),
    },
    {
      "@type": "ItemList",
      "@id": `${siteUrl}/#projects`,
      name: "Projects by Ansh Jatana",
      itemListElement: projects.map((project, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "SoftwareApplication",
          name: project.name,
          description: project.description[0],
          applicationCategory: "WebApplication",
          ...(project.liveURL && { url: project.liveURL }),
        },
      })),
    },
  ],
};
